import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  ArrowIcon,
  CasesIcon,
  DocumentIcon,
  HelpIcon,
  HomeIcon,
  IconComponent,
  NotificationIcon,
  UserprofileIcon,
  type IconDef,
} from '../../../../../../../libs/core';

interface PortalNavItem {
  readonly label: string;
  readonly path: string;
  readonly icon: IconDef;
  readonly badge?: number;
  readonly exact?: boolean;
}

interface PortalNavGroup {
  readonly title: string;
  readonly items: readonly PortalNavItem[];
}

@Component({
  selector: 'app-portal-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, IconComponent, NgClass],
  templateUrl: './portal-sidebar.component.html',
})
export class PortalSidebarComponent {
  @Input() collapsed = false;
  @Output() readonly toggleCollapse = new EventEmitter<void>();

  protected readonly arrowIcon: IconDef = ArrowIcon;

  protected readonly navGroups: readonly PortalNavGroup[] = [
    {
      title: 'Workspace',
      items: [
        { label: 'Dashboard', path: '/dashboard', icon: HomeIcon, exact: true },
        { label: 'My Cases',  path: '/cases',     icon: CasesIcon, badge: 3 },
        { label: 'Documents', path: '/documents',  icon: DocumentIcon },
      ],
    },
    {
      title: 'Communication',
      items: [
        { label: 'Messages', path: '/messages', icon: NotificationIcon, badge: 5 },
      ],
    },
  ];

  protected readonly footerItems: readonly PortalNavItem[] = [
    { label: 'Profile',     path: '/profile',     icon: UserprofileIcon },
    { label: 'Help Center', path: '/help-center',  icon: HelpIcon },
  ];
}
